import request from '@/utils/request'
export function getSoftList (params) {
  return request({
    url: '/hr/topictheme/page',
    method: 'GET',
	params
  })
}
export function getDetail (id) {
  return request({
    url: '/hr/topictheme/info/' + id,
    method: 'GET'
  })
}
// 获取软件分类
export function getType (params) {
  return request({
    url: '/hr/topictype/fetchAllSoftwareType',
    method: 'GET',
	params
  })
}

// 软件评价
export function publishCommit (data) {
  return request({
    url: '/hr/topic/commit',
    method: 'POST',
	data
  })
}

// 收藏软件
export function softCollect (data) {
  return request({
    url: '/hr/collectionrecord',
    method: 'POST',
	data
  })
}
// 获取软件点评列表
export function getCommentlist (params) {
  return request({
    url: '/hr/topic/page/softwareComment',
    method: 'GET',
	params
  })
}
// 获取软件问答列表
export function getQAlist (params) {
  return request({
    url: '/hr/questionandanswer/page/que',
    method: 'GET',
	params
  })
}
// 获取软件问答详情
export function getQAdetail (id) {
  return request({
    url: `/hr/questionandanswer/info/${id}`,
    method: 'GET',
  })
}
// 提问/回答提问 type 0提问 1回答
export function commitQA (data) {
  return request({
    url: '/hr/questionandanswer/commit',
    method: 'POST',
	data
  })
}
// 点赞问答
export function likerecord (data) {
  return request({
    url: '/hr/likerecord',
    method: 'POST',
	data
  })
}